import { useQuery } from "@apollo/client/react";
import dayjs from "dayjs";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import type { ClientsWithInvoicesModel } from "../../../models/ClientsWithInvoicesModel";
import type {
  InvoiceAssessmentStatus,
  InvoiceProcessStatus,
  InvoiceRegistrationStatus,
  InvoiceValidationStatus,
} from "../../../models/InvoiceStatusModel";
import type { InvoiceTag } from "../../../models/InvoiceTags";

type ClientAggregationSortBy =
  | "CLIENT_IDENTIFIER"
  | "FILTERED_TOTAL_AMOUNT"
  | "FILTERED_TOTAL_COUNT";

export const useClientsWithInvoices = (
  invoiceStatuses: InvoiceProcessStatus[],
  skip: number,
  take: number,
  sortBy?: ClientAggregationSortBy,
  sortDirection?: "ASC" | "DESC",
  invoiceDateFrom?: Date,
  invoiceDateTo?: Date,
  dueDateFrom?: Date,
  dueDateTo?: Date,
  amountFrom?: number,
  amountTo?: number,
  tags?: InvoiceTag[],
  clientIdentifier?: string,
  registrationStatuses?: InvoiceRegistrationStatus[],
  validationStatuses?: InvoiceValidationStatus[],
  assessmentStatuses?: InvoiceAssessmentStatus[],
) => {
  const { data, error, loading, refetch } = useQuery<{
    clientsWithInvoices: ClientsWithInvoicesModel;
  }>(GET_CLIENTS_WITH_INVOICES, {
    variables: {
      invoiceStatuses,
      clientIdentifier,
      sortBy,
      sortDirection,
      invoiceDateFrom: invoiceDateFrom
        ? dayjs(invoiceDateFrom).format("YYYY-MM-DD")
        : undefined,
      invoiceDateTo: invoiceDateTo
        ? dayjs(invoiceDateTo).format("YYYY-MM-DD")
        : undefined,
      dueDateFrom: dueDateFrom
        ? dayjs(dueDateFrom).format("YYYY-MM-DD")
        : undefined,
      dueDateTo: dueDateTo ? dayjs(dueDateTo).format("YYYY-MM-DD") : undefined,
      amountFrom,
      amountTo,
      tags,
      registrationStatuses,
      validationStatuses,
      assessmentStatuses,
      skip,
      take,
    },
    errorPolicy: "all",
  });
  return {
    clientsWithInvoices: data?.clientsWithInvoices,
    error,
    loading,
    refetch,
  };
};
